import styled from 'styled-components'

export const StyledNotFound = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;

  section {
    border: 1px solid ${props => props.theme.colors.black[100]};
    border-radius: ${props => props.theme.radius.default};
    background-color: ${props => props.theme.colors.white[500]};
    padding: ${props => props.theme.spacing.xlarge};

    h1 {
      font-size: ${props => props.theme.font.medium};
      font-weight: ${props => props.theme.fontWeight.medium};
    }
  }
`
